export class PersonHeaderSearchCriteria {

  searchTerm!: string;
  orgUnitId!: string;
  statusCode!: string;
  pageNumber!: number;

}
